class LiveEvent extends HTMLElement {
  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.initReadMore();
    this.initCarousels();
    this.initVideoPlay();
    this.initPermalinks();
  }

  /* ── Read More / Read Less ── */
  initReadMore() {
    this.querySelectorAll('.le-card__readmore').forEach(function(btn) {
      var card = btn.closest('[id^="update-"]');
      var wrap = card ? card.querySelector('.le-card__content-wrap') : null;
      var gradient = wrap ? wrap.querySelector('.le-card__gradient') : null;
      if (!wrap || !gradient) return;

      var expanded = false;
      var icon = btn.querySelector('.le-readmore-icon');
      btn.addEventListener('click', function() {
        expanded = !expanded;
        if (expanded) {
          wrap.style.maxHeight = 'none';
          gradient.style.display = 'none';
          btn.querySelector('.le-readmore-text').textContent = 'READ LESS';
          if (icon) icon.style.transform = 'rotate(180deg)';
        } else {
          wrap.style.maxHeight = '240px';
          gradient.style.display = '';
          btn.querySelector('.le-readmore-text').textContent = 'READ MORE';
          if (icon) icon.style.transform = '';
        }
      });
    });
  }

  /* ── Image Carousel (Swiper) ── */
  initCarousels() {
    if (typeof Swiper === 'undefined') return;

    this.querySelectorAll('.le-swiper-wrap').forEach(function(wrap) {
      var swiperEl = wrap.querySelector('.le-swiper');
      var prevBtn = wrap.querySelector('.le-swiper-prev');
      var nextBtn = wrap.querySelector('.le-swiper-next');
      var paginationEl = wrap.querySelector('.le-dots');
      if (!swiperEl) return;

      function updateGradient(sw) {
        swiperEl.classList.toggle('le-swiper--at-end', sw.isEnd);
      }

      var swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        loop: false,
        pagination: {
          el: paginationEl,
          clickable: true,
          bulletClass: 'carousel__page cursor-pointer',
          bulletActiveClass: 'active'
        },
        on: {
          init: function(sw) { updateGradient(sw); },
          slideChange: function(sw) { updateGradient(sw); },
          reachEnd: function(sw) { updateGradient(sw); },
          fromEdge: function(sw) { updateGradient(sw); }
        }
      });

      if (prevBtn) prevBtn.addEventListener('click', function() { swiper.slidePrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { swiper.slideNext(); });
    });
  }

  /* ── Video Play ── */
  initVideoPlay() {
    this.querySelectorAll('.le-card__video-play').forEach(function(btn) {
      var wrapper = btn.closest('.le-card__video');
      var comp = wrapper ? wrapper.querySelector('video-component') : null;
      var video = comp ? comp.querySelector('video') : null;
      var duration = wrapper ? wrapper.querySelector('.le-card__duration') : null;
      if (!video) return;

      btn.addEventListener('click', function() {
        var sources = video.querySelectorAll('source[data-src]');
        sources.forEach(function(s) {
          if (!s.src) s.src = s.dataset.src;
        });
        if (sources.length) video.load();

        video.muted = false;
        video.controls = true;
        video.play();
        btn.style.display = 'none';
        if (duration) duration.style.display = 'none';
      });
    });
  }

  /* ── Permalink Copy ── */
  initPermalinks() {
    this.querySelectorAll('.le-card__permalink').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var anchor = btn.getAttribute('data-anchor');
        var url = window.location.origin + window.location.pathname + '#' + anchor;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url);
        }
      });
    });
  }
}

customElements.define('live-event', LiveEvent);
